module.exports = __webpack_public_path__ + "h5/img/huangguan_bg.0692711c.png";